import type { ReactNode } from 'react';

import { usePermissions } from '@/hooks/usePermissions';
import { useSupabase } from '@/hooks/useSupabase';
import type { AppPermission } from '@/types/app-permissions';

interface Props {
  /** Alcanza con tener cualquiera de estos permisos. */
  permissions: AppPermission[];
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Como `RequirePermission`, pero deja pasar a quien tenga CUALQUIERA de varios
 * permisos. Sirve para una pantalla que junta partes con permisos distintos
 * (Personas: `employees.view` o `users.manage`); cada parte se sigue montando
 * solo con su propio permiso adentro de la pantalla.
 *
 * Mientras la sesión carga no decide nada, igual que `RequirePermission`:
 * «todavía no sé» no es «no».
 */
export function RequireAnyPermission({ permissions, children, fallback = null }: Props) {
  const { loading } = useSupabase();
  const { hasAny } = usePermissions();
  if (loading) return null;
  return <>{hasAny(permissions) ? children : fallback}</>;
}
